
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"joinCommunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvitationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tmpGns3Purpose"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tmpMarketingSubscribe"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userFirstName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userLastName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userLocation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userOrganization"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinCommunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invitation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitation"}}},{"kind":"Argument","name":{"kind":"Name","value":"tmpGns3Purpose"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tmpGns3Purpose"}}},{"kind":"Argument","name":{"kind":"Name","value":"tmpMarketingSubscribe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tmpMarketingSubscribe"}}},{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"userFirstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userFirstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userLastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userLastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"userLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userLocation"}}},{"kind":"Argument","name":{"kind":"Name","value":"userOrganization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userOrganization"}}},{"kind":"Argument","name":{"kind":"Name","value":"userPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPassword"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelationshipFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":714}};
    doc.loc.source = {"body":"#import '../fragments/Relationship.gql'\n\nmutation joinCommunity(\n   $invitation: InvitationInput\n   $tmpGns3Purpose: String\n   $tmpMarketingSubscribe: Boolean\n   $userEmail: String!\n   $userFirstName: String\n   $userLastName: String\n   $userLocation: LocationInput\n   $userOrganization: String\n   $userPassword: String!\n) {\n   joinCommunity(\n      invitation: $invitation\n      tmpGns3Purpose: $tmpGns3Purpose\n      tmpMarketingSubscribe: $tmpMarketingSubscribe\n      userEmail: $userEmail\n      userFirstName: $userFirstName\n      userLastName: $userLastName\n      userLocation: $userLocation\n      userOrganization: $userOrganization\n      userPassword: $userPassword\n   ) {\n      ...RelationshipFragment\n   }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../fragments/Relationship.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["joinCommunity"] = oneQuery(doc, "joinCommunity");
        
